/* V3 cart drawer: one-tap add for the in-drawer upsell.
   Adds via /cart/add.js and re-renders the drawer with Dawn's own
   renderContents, so quantities, notes, the gift checkbox and the
   personalization interceptor all keep working unchanged. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v3-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var id = parseInt(btn.dataset.v3UpsellAdd, 10);
    if (!id) return;
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : ['cart-drawer', 'cart-icon-bubble'];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (state) {
      if (state.status) throw new Error(state.description || 'Could not add');
      if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
      else window.location.href = '/cart';
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'drawer_upsell_add', variant_id: id }); } catch (err) {}
    }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); btn.textContent = 'Try again'; });
  });
})();
